import { SetStateAction } from 'react'
import { parseAsArrayOf, parseAsInteger, useQueryState } from 'nuqs'
import { Slider } from '~/components/UI/shadcn/slider'

type SldierInput = {
  disabled: true | false
  start: string | undefined | null
  end: string | undefined | null
  value: number[]
  min: number
  max: number
  step: number
  queryKey?: string
}

const FormUISlider = (props: SldierInput) => {
  const { disabled, start, end, value, min, max, step, queryKey } = props
  // const [range, setRange] = useState(value)

  const [query = [], setQuery] = useQueryState<number[]>(
    queryKey || 'filters',
    parseAsArrayOf(parseAsInteger, ',').withDefault(value)
  )

  const normalisedQuery = query || []

  const handleRangeChange = (value: SetStateAction<number[]>) => {
    // setRange(value)
    setQuery(value)
  }

  return (
    <div className='py-6'>
      <Slider
        start={start || ''}
        end={end || ''}
        min={min || 0}
        max={max || 0}
        step={step || 1}
        disabled={disabled || false}
        minStepsBetweenThumbs={1}
        value={normalisedQuery}
        onValueChange={handleRangeChange}
      />
    </div>
  )
}

export default FormUISlider
